import * as React from 'react';
import {appendErrors} from 'react-hook-form';
export type NLSTextInputPropsType = {
  defaultValue: string;
  name: string;
  label: string;
  register: any;
  //rest: any | undefined;
  errors: any | undefined | null;
  validation: any;
};
export const NLSTextInput = ({
  defaultValue,
  name,
  label,
  register,
  errors,
  validation,
}: NLSTextInputPropsType) => {
  //console.log(errors[name]);
  return (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={name}
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type="text"
        defaultValue={defaultValue}
        {...register(name, validation)}
      />
      {errors[name] && <p>Error occurred {errors[name].message}</p>}
    </div>
  );
};
